import styled from "styled-components";

export default styled.div`
	background-color: var(--background-tertiary);
	color: var(--text);
	overflow: hidden;
	display: flex;
`;
